import { Component, Host, Prop, h } from '@stencil/core';

/**
 * @description A "person image" which is displayed in a circle.
 * @ignore - This is a subcomponent, do not display in catalog
 * @version 0
 */
@Component({
  tag: 'hp6-person-image',
  styleUrl: 'person-image.scss',
  shadow: true,
})
export class PersonImage {
  iconSize = {
    xs: 'sm',
    sm: 'md',
    md: 'lg',
    lg: 'lg',
    xl: 'xl',
    xxl: 'xl',
  };

  sizes = {
    xs: 42,
    sm: 72,
    md: 108,
    lg: 132,
    xl: 192,
    xxl: 246,
  };

  /**
   * The source of the person image in this
   */
  @Prop({ reflect: true }) src: string = '';

  /**
   * Boolean if this person is a doctor. If the src property is missing, and
   * therefore cannot load the image, a specific "missing image" icon is chosen
   * based on whether or not the person is a doctor.
   */
  @Prop() isDoctor: boolean = false;

  /**
   * Background image source
   */
  @Prop() backgroundImageSrc: string = '';

  /**
   * Used to set the alt attribute of the img element
   */
  @Prop() imageAltText: string = '';

  /**
   * Size of the image at xsmall breakpoint and up
   */
  @Prop() sizeXsSelection: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' = 'md';

  /**
   * Size of the image at small breakpoint
   */
  @Prop() sizeSmSelection: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

  /**
   * Size of the image at medium breakpoint
   */
  @Prop() sizeMdSelection: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

  /**
   * Size of the image at large breakpoint
   */
  @Prop() sizeLgSelection: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

  get sizeClass() {
    const { sizeXsSelection, sizeSmSelection, sizeMdSelection, sizeLgSelection } = this;
    const value = [];

    if (sizeXsSelection) {
      value.push(`size-xs-${sizeXsSelection}`);
    }
    if (sizeSmSelection) {
      value.push(`size-sm-${sizeSmSelection}`);
    }
    if (sizeMdSelection) {
      value.push(`size-md-${sizeMdSelection}`);
    }
    if (sizeLgSelection) {
      value.push(`size-lg-${sizeLgSelection}`);
    }
    return value.join(' ');
  }

  render() {
    const { src, imageAltText, isDoctor, backgroundImageSrc, iconSize, sizes } = this;
    const { sizeXsSelection, sizeSmSelection, sizeMdSelection, sizeLgSelection, sizeClass } = this;

    return (
      <Host class={sizeClass}>
        {src
          ? (
              <div class="image-container">
                <img
                  src={src}
                  alt={imageAltText || ''}
                  loading="lazy"
                  height={sizes[sizeXsSelection]}
                  width={sizes[sizeXsSelection]}
                  style={{
                    backgroundImage: `url('${backgroundImageSrc}')`,
                  }}
                />
              </div>
            )
          : (
              <hp6-icon
                name={isDoctor ? 'brand-doctor-3' : 'brand-business-man'}
                size-xs-selection={iconSize[sizeXsSelection]}
                size-sm-selection={iconSize[sizeSmSelection]}
                size-md-selection={iconSize[sizeMdSelection]}
                size-lg-selection={iconSize[sizeLgSelection]}
              />
            )}
      </Host>
    );
  }
}
